import { combineReducers } from 'redux';

import deltaConfig from 'app/features/deltaConfig/reducer';
import landing from 'app/features/landing/reducer';
import user from 'app/features/user/reducers';
import billing from 'app/features/billing/reducer';
import news from 'app/features/news/reducers';
import series from 'app/features/series/reducers';
import watchlist from 'app/features/watchlist/reducers';
import success from 'app/features/success/reducers';
import localization from 'app/features/localization/reducers';
import flashMessage from 'app/features/flashMessage/reducers';
import checkout from 'app/features/checkout/reducers';
import authentication from 'app/features/authentication/reducers';
import plans from 'app/features/plans/reducers';
import products from 'app/features/products/reducer';
import coupon from 'app/features/couponCampaign/reducers';
import router from 'app/router/reducer';
import theme from 'app/styles/reducers';

const createRootReducer = history =>
  combineReducers({
    router: router(history),
    user,
    deltaConfig,
    landing,
    billing,
    localization,
    news,
    series,
    watchlist,
    success,
    flashMessage,
    checkout,
    authentication,
    products,
    coupon,
    plans,
    theme,
  });

export default createRootReducer;
